import { z } from 'zod';
/** Minimum length 12, max 256. No composition rules — modern OWASP
 *  guidance is to encourage length + password managers, not to drive
 *  users into bad-but-rule-satisfying passwords like "Password1!".
 *  Strength signaling is a UI concern, not a server-rejection one. */
export const NewPasswordSchema = z
    .string()
    .min(12, 'Password must be at least 12 characters')
    .max(256);
/** POST /api/v1/auth/sign-in body.
 *  Co-equal sign-in method alongside magic-link (system design §8.1). */
export const SignInRequestSchema = z.object({
    email: z.string().email().max(254).toLowerCase(),
    password: z.string().min(1).max(256), // detect blanks; real strength is checked on set
});
/** POST /api/v1/auth/password body — change the signed-in user's password.
 *  currentPassword is required when the user already has one set; it is
 *  null/omitted for users adopting a password for the first time (they
 *  signed in via magic-link, then chose to set a password). */
export const PasswordChangeRequestSchema = z.object({
    currentPassword: z.string().min(1).max(256).nullable().optional(),
    newPassword: NewPasswordSchema,
});
/** POST /api/v1/auth/password-reset/request body.
 *  Always returns 200 even for unknown emails — no account enumeration. */
export const PasswordResetRequestSchema = z.object({
    email: z.string().email().max(254).toLowerCase(),
});
/** POST /api/v1/auth/password-reset/request response.
 *  Same envelope shape as MagicLinkRequestResponseSchema. */
export const PasswordResetRequestResponseSchema = z.object({
    status: z.literal('queued'),
    message: z.string(),
});
/** POST /api/v1/auth/password-reset/confirm body.
 *  Single-use token + new password. On success, all of the user's
 *  existing sessions are revoked (the password may have been
 *  compromised, so any active sessions are suspect). */
export const PasswordResetConfirmSchema = z.object({
    token: z.string().min(32).max(256),
    newPassword: NewPasswordSchema,
});
//# sourceMappingURL=password.schema.js.map